import * as React from 'react';

import type {GetPlanComparisons_planComparisons as PlanComparisons} from 'nutshell-graphql-types';

import type {SuiteType} from '../../plan-comparison-root';

export const useGetPlanComparisons = (
    suiteType: SuiteType
): {
    isLoading: boolean;
    planComparisons: PlanComparisons | null | undefined;
} => {
    const [loading, setLoading] = React.useState(false);
    const [planComparisons, setPlanComparisons] = React.useState<
        PlanComparisons | null | undefined
    >(null);

    React.useEffect(() => {
        const getPlanComparisons = async () => {
            setLoading(true);

            const data = await fetch(`/public-billing/plan-comparisons?suiteType=${suiteType}`);
            if (data.status >= 200 && data.status < 300) {
                const planComparisonData = await data.json();
                setPlanComparisons(planComparisonData.plans.data.planComparisons);
            }

            setLoading(false);
        };

        getPlanComparisons();
    }, [suiteType]);

    return {
        isLoading: loading,
        planComparisons,
    };
};
